export default __webpack_public_path__ + "static/media/vr-picture.74bbd0d6.png";